module.exports = __webpack_public_path__ + "img/logo-ine.fdb7f981.jpg";